<template>
  <div>
    <template>
      <div
        class="product-block"
        v-for="(product, index) in productList"
        :key="index"
      >
        <div
          class="product-time"
          v-if="
            (product.valid_from &&
              product.valid_to &&
              +product.product_id !== WABA_PRODUCT_ID) || product.is_multi_account
          "
        >
          <div
            v-if="product.valid_from && product.valid_to && +product.product_id !== WABA_PRODUCT_ID"
          >
            {{ $t("home.expiration") }}：{{ product.valid_from | dateFormat }} ~
            {{ product.valid_to | dateFormat }}
            <span v-if="product.max_valid_to">
              （{{ $t("home.latest_expiration") }}：{{ product.max_valid_to }}）
            </span>
          </div>
          <div v-if="product.is_multi_account">
            <span>{{ product.business_name }}</span>
            <span v-if="+product.business_id !=0">（{{ product.business_id }}）</span>
          </div>
        </div>
        <div class="product-info">
          <div class="product-name">
            {{ product.version_name }}
          </div>
          <div
            v-for="service in product.service_list"
            :key="service.service_id"
          >
            <span v-if="service.service_id != SERVICE_ID_ERPHELP">
              {{ service.service_name }}
              <span v-if="!isJapan">：</span>
              <!-- 存在label则优先显示label，不存在走原逻辑 -->
              <template v-if="service.label">
                {{ service.label }}
              </template>
              <template v-else>
                <span v-text="renderPurchasedUsed(service, product.group_name)" />
                <span
                  class="usable"
                  v-text="renderUsable(service, product.group_name)"
                />
                <span
                  v-if="isExclusiveWorkTimeService(service) && Number(service.pending_count) > 0"
                  v-text="renderPending(service)"
                />
              </template>
              <a
                v-if="
                  product.group_name === CRM_GROUP &&
                    product.valid_from &&
                    product.valid_to &&
                    +service.service_id == SERVICE_ID_ACCOUNT &&
                    isAdmin
                "
                :href="accountLink"
                target="_blank"
              >
                {{ $t("home.detail") }}</a>
              <a
                v-if="
                  product.group_name === CRM_GROUP &&
                    product.valid_from &&
                    product.valid_to &&
                    +service.service_id == SERVICE_ID_SPACE &&
                    isAdmin
                "
                :href="spaceLink"
                target="_blank"
              >
                {{ $t("home.detail") }}</a>
              <a
                v-if="+service.service_id == SERVICE_ID_WABA"
                :href="wabaLink"
                target="_blank"
              >
                {{ $t("home.detail") }}</a>
              <a
                v-if="isWorkTimeService(service) && isAdmin"
                :href="worktimeLink"
                target="_blank"
              >
                {{ $t("home.detail") }}</a>
            </span>
          </div>
        </div>
        <div
          class="product-action"
          v-if="product.button_type > 0"
        >
          <span v-if="(!isCanBuy || isTaiwanClient) && +product.button_type === ACTION_RENEW">续约请联系销售</span>
          <span v-else-if="Number(product.button_type) === 5">发布中</span>
          <span v-else-if="Number(product.button_type) === 6">{{ product.button_message }}</span>
          <mm-button
            v-else
            class="btn"
            type="primary"
            @click="handleProductAction(product.button_type, product.order_id, product.id)"
          >
            {{ actionButtonText(product.button_type) }}
          </mm-button>
        </div>
        <div
          class="product-action"
          v-else
        >
          <span v-if="Number(product.product_id) === PRODUCT_ID_SHOP_MARKETING">站点上线后可增购</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import {
    SERVICE_ID_ACCOUNT,
    SERVICE_ID_EDM,
    SERVICE_ID_SPACE,
    // SERVICE_ID_PAGE,
    SERVICE_ID_DISCOVERY,
    SERVICE_ID_ERPAPI,
    SERVICE_ID_ERPHELP,
    SERVICE_ID_BILLS,
    SERVICE_ID_PROCESS,
    SERVICE_ID_STAT,
    SERVICE_ID_ADS_ADVANCE,
    SERVICE_ID_OMS,
    SERVICE_ID_OKKI_API_BASE,
    SERVICE_ID_HUNTER,
    SERVICE_ID_SAVE,
    SERVICE_ID_MODULE,
    SERVICE_ID_FINANCE,
    SERVICE_ID_WABA,
    SERVICE_ID_SHOP,
    SERVICE_ID_K_COIN,
    SERVICE_ID_K_COIN_2,
    SERVICE_ID_WECHAT_LICENSE,
    SERVICE_ID_WECHAT_ARCHIVE,
    SERVICE_ID_WA_COMMUNICATE_FUNCTION,
    SERVICE_ID_WA_MARKETING_FUNCTION,
    SERVICE_ID_OVERSEA_MANAGEMENT,
    SERVICE_ID_OVERSEA_CHECK_IN,
    SERVICE_ID_EXCLUSIVE_WORK_TIME,
    SERVICE_ID_GENERAL_WORK_TIME,
  } from '@utils/constants'
  import Servers from '@config'
  import {PRODUCT_ID_SHOP_MARKETING} from "../../../utils/constants";

  const ACTION_NONE = 0
  const ACTION_RENEW = 1
  const ACTION_ACTIVATE = 2
  const ACTION_AUTH = 3
  const ACTION_APPEND = 4
  const ACTION_UPGRADE = 7
  const ACTION_AIREACH_ACT = 8
  const noAddtionService = [
    SERVICE_ID_DISCOVERY,
    SERVICE_ID_ERPAPI,
    SERVICE_ID_ERPHELP,
    SERVICE_ID_BILLS,
    SERVICE_ID_PROCESS,
    SERVICE_ID_STAT,
    SERVICE_ID_OKKI_API_BASE,
    SERVICE_ID_OMS,
    SERVICE_ID_HUNTER,
    SERVICE_ID_SAVE,
    SERVICE_ID_MODULE,
    SERVICE_ID_FINANCE,
    SERVICE_ID_K_COIN,
    SERVICE_ID_OVERSEA_MANAGEMENT,
  ]
  const hideUsedNumService = [
    SERVICE_ID_WECHAT_LICENSE,
    SERVICE_ID_WECHAT_ARCHIVE,
    SERVICE_ID_WA_MARKETING_FUNCTION,
    SERVICE_ID_WA_COMMUNICATE_FUNCTION,
    SERVICE_ID_OVERSEA_MANAGEMENT,
  ]
  // 专属工时展示已发、可用和待发，通用工时展示可用；主账号可查看明细
  const workTimeService = [
    SERVICE_ID_EXCLUSIVE_WORK_TIME,
    SERVICE_ID_GENERAL_WORK_TIME,
  ]
  const CRM_GROUP = '1711'
  const WABA_GROUP = 'waba'
  const WABA_PRODUCT_ID = 32;
  const SHOPPING_GROUP = 'shop_marketing'

  export default {
    name: 'HomeProductBlock',
    data() {
      return {
        SERVICE_ID_ERPHELP,
        SERVICE_ID_ACCOUNT,
        SERVICE_ID_SPACE,
        CRM_GROUP,
        ACTION_RENEW,
        SERVICE_ID_WABA,
        WABA_PRODUCT_ID,
        PRODUCT_ID_SHOP_MARKETING,
      }
    },
    computed: {
      ...mapState('home', {
        productList: state => state.productList
      }),
      ...mapGetters("main", ["isAdmin", "isAliUser","isCanBuy", "isTaiwanClient"]),
      accountLink() {
        return `${Servers.crm}/management/account/accountRecord`
      },
      spaceLink() {
        return `${Servers.crm}/management/account/spatialDetail`
      },
      wabaLink() {
        return `${Servers.crm}/talk/socialMediaManage/waba?module=ConversatioinList`
      },
      worktimeLink() {
        return `${window.location.origin}/worktime/`
      },
      isJapan() {
        return window.location.host.includes('okki.ai')
      },
      separator() {
        return this.isJapan ? ': ' : '';
      }
    },
    methods: {
      handleProductAction (type, orderId, orderProductId) {
        const actionMap = {
          [ACTION_NONE]: () => {},
          [ACTION_RENEW]: () => this.$emit('onRenew'),
          [ACTION_ACTIVATE]: () => this.$emit('onActivate', orderId, orderProductId, false),
          [ACTION_AUTH]: () => this.$emit('onAuth'),
          [ACTION_APPEND]: () => this.$emit('onAppend'),
          [ACTION_UPGRADE]: () => this.$emit('onUpgrade', orderId, orderProductId),
          [ACTION_AIREACH_ACT]: () => this.$emit('onAireachActivate', orderId, orderProductId),
        }
        actionMap[type]()
      },
      actionButtonText (val) {
        const actionMap = {
          [ACTION_NONE]: '',
          [ACTION_RENEW]: this.$t('product.renew'),
          [ACTION_ACTIVATE]: this.$t('product.activate'),
          [ACTION_AUTH]: this.$t('product.activate'),
          [ACTION_APPEND]: this.$t('product.append'),
          [ACTION_UPGRADE]: this.$t('product.activate'),
          [ACTION_AIREACH_ACT]: this.$t('product.activate'),
        }
        return actionMap[val]
      },
      isWorkTimeService(service) {
        return workTimeService.includes(~~service.service_id)
      },
      isExclusiveWorkTimeService(service) {
        return ~~service.service_id === SERVICE_ID_EXCLUSIVE_WORK_TIME
      },
      renderPurchasedUsed(service, groupName) {
        if (this.isExclusiveWorkTimeService(service)) {
          return `${this.$t('service.granted') + this.separator + (service.granted_count || 0) + service.unit_desc}／ `
        }
        const idList = [SERVICE_ID_EDM, SERVICE_ID_ADS_ADVANCE, SERVICE_ID_WABA, SERVICE_ID_SHOP, SERVICE_ID_K_COIN_2, SERVICE_ID_OVERSEA_CHECK_IN]
        if (idList.includes(~~service.service_id) || this.isWorkTimeService(service)) {
          return ''
        }
        if (noAddtionService.includes(~~service.service_id) || groupName !== CRM_GROUP || hideUsedNumService.includes(~~service.service_id)) {
          return `${this.$t('service.purchased') + this.separator + service.buy_count + service.unit_desc }`
        }
        return `${this.$t('service.purchased') + this.separator + service.buy_count + service.unit_desc }／
              ${this.$t('service.used') + this.separator + service.used_count + service.unit_desc }／ `
      },
      renderUsable(service, groupName) {
        if (this.isWorkTimeService(service)) {
          const label = this.isExclusiveWorkTimeService(service) ? 'service.available' : 'service.remaining'
          return `${this.$t(label) + this.separator + service.left_count + service.unit_desc}`
        }
        if (hideUsedNumService.includes(~~service.service_id)) {
          return ''
        }
        if (noAddtionService.includes(~~service.service_id) || groupName !== CRM_GROUP) {
          const groupList = [WABA_GROUP, SHOPPING_GROUP]
          if (groupList.includes(groupName)) {
            return `${this.$t('service.available') + this.separator + service.left_count + service.unit_desc}`
          }
          return ''
        }

      if (service.service_id == SERVICE_ID_ADS_ADVANCE) {
        return `${this.$t("service.available") + this.separator + service.unit_desc + service.left_count}`;
      }
      return `${this.$t("service.available") + this.separator + service.left_count + service.unit_desc}`;
    },
    renderPending(service) {
      return `／ ${this.$t('service.pendingGrant') + this.separator + service.pending_count + service.unit_desc}`
    },
  },
};
</script>
<style lang="scss" scoped>
%common {
  padding-right: 20px;
  padding-left: 20px;
}
.product {
  &-block {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    overflow: hidden;
  }
  &-time {
    @extend %common;
    display: flex;
    width: 100%;
    align-items: center;
    height: 38px;
    background: #f5f5f5;
  }
  &-info {
    @extend %common;
    padding-bottom: 10px;
    line-height: 30px;
    color: #5d5d5d;
    .usable {
      font-size: 14px;
      font-weight: 600;
      color: #2a2a2a;
    }
  }
  &-name {
    padding: 17px 0 5px;
    font-size: 18px;
    font-weight: 600;
    color: #2a2a2a;
  }
  &-action {
    display: flex;
    flex: 0 1 220px;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-left: 1px solid #e6e6e6;
    .btn {
      position: absolute;
    }
  }
}
</style>
